import { render, staticRenderFns } from "./FansUpload.vue?vue&type=template&id=9a069e38&"
import script from "./FansUpload.vue?vue&type=script&lang=ts&"
export * from "./FansUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FansUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports